import { useEffect, useState } from 'react'

import { css } from 'styled-components'

/**
 * @description This hook intentionally rerenders once on mount so that refs are populated for effects
 */
export const useRerender = () => {
  const [hasRendered, setHasRendered] = useState(false)
  useEffect(() => {
    let timeout: NodeJS.Timeout
    if (!hasRendered) {
      timeout = setTimeout(() => {
        setHasRendered(true)
      })
    }
    return () => clearTimeout(timeout)
  }, [hasRendered])
}

export type InputStyleProps = {
  $isDisabled: boolean
  $isInvalid: boolean
}
export const InputStyles = css<InputStyleProps>`
  ${({ $isDisabled, theme }) =>
    $isDisabled
      ? `
      pointer-events: none;
      background-color: ${theme.controlItemBgActiveDisabled};
  `
      : `
      background-color: ${theme.colorWhite};
      &:hover: {
        border-color: ${theme.colorPrimaryHover};
      }
  `}

  ${({ $isInvalid, theme }) =>
    $isInvalid &&
    `
    border-color: ${theme.colorErrorBase};
  `};

  &:focus-within {
    border-color: ${({ $isInvalid, theme }) =>
      $isInvalid ? theme.colorErrorBase : theme.colorPrimaryBase};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.controlOutline};
  }
`

export const getValueOfTailwindVariable = (themeVariable: string) => {
  const styles = getComputedStyle(document.documentElement)
  return styles.getPropertyValue(themeVariable)
}
